import { tracker } from '../track';
import { mapArticleToGA4EcommerceItem } from '../../helpers';
export const trackViewPromotion = (payload, options) => {
    try {
        const { creativeName, element, itemListName, items, creativeSlot } = payload;
        tracker.track('GA4-EEC-view_promotion', {
            event_name: 'view_promotion',
            view_promotion: {
                element: element || null,
                creative_name: creativeName || null,
                creative_slot: creativeSlot !== undefined ? creativeSlot : null,
                promotion_id: null,
                promotion_name: null,
                length: null,
                items: items.map((item, index) => {
                    var _a, _b;
                    return mapArticleToGA4EcommerceItem(Object.assign({ affiliation: item.categoryId || null, index: (_a = item.index) !== null && _a !== void 0 ? _a : index, promotion_id: item.campaignIdentifier, item_list_name: itemListName, plus_exclusive: (item === null || item === void 0 ? void 0 : item.isExclusiveItem) || null }, (_b = options === null || options === void 0 ? void 0 : options.customMapper) === null || _b === void 0 ? void 0 : _b.call(options, item)));
                }),
            },
        });
    }
    catch (e) {
        // eslint-disable-next-line no-console
        console.error('[@browsing/tracker] Tracking `view_promotion` failed.', e);
    }
};
